import { render, staticRenderFns } from "./Matches.vue?vue&type=template&id=12a5c0cc&scoped=true&"
import script from "./Matches.vue?vue&type=script&lang=ts&"
export * from "./Matches.vue?vue&type=script&lang=ts&"
import style0 from "./Matches.vue?vue&type=style&index=0&id=12a5c0cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a5c0cc",
  null
  
)

export default component.exports